import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
// src/env.tsx
import { useSafeLayoutEffect } from "@chakra-ui/react-use-safe-layout-effect";
import { createContext, useContext, useMemo, useReducer, useRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
var EnvironmentContext = createContext({
  getDocument: function getDocument() {
    return document;
  },
  getWindow: function getWindow() {
    return window;
  }
});
EnvironmentContext.displayName = "EnvironmentContext";
function useEnvironment() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    defer = _ref.defer;
  var _useReducer = useReducer(function (c) {
      return c + 1;
    }, 0),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    forceUpdate = _useReducer2[1];
  useSafeLayoutEffect(function () {
    if (!defer) return;
    forceUpdate();
  }, [defer]);
  return useContext(EnvironmentContext);
}
function EnvironmentProvider(props) {
  var children = props.children,
    environmentProp = props.environment,
    disabled = props.disabled;
  var ref = useRef(null);
  var context = useMemo(function () {
    if (environmentProp) return environmentProp;
    return {
      getDocument: function getDocument() {
        var _a, _b;
        return (_b = (_a = ref.current) == null ? void 0 : _a.ownerDocument) != null ? _b : document;
      },
      getWindow: function getWindow() {
        var _a, _b;
        return (_b = (_a = ref.current) == null ? void 0 : _a.ownerDocument.defaultView) != null ? _b : window;
      }
    };
  }, [environmentProp]);
  var showSpan = !disabled || !environmentProp;
  return /* @__PURE__ */jsxs(EnvironmentContext.Provider, {
    value: context,
    children: [children, showSpan && /* @__PURE__ */jsx("span", {
      id: "__chakra_env",
      hidden: true,
      ref: ref
    })]
  });
}
EnvironmentProvider.displayName = "EnvironmentProvider";
export { useEnvironment, EnvironmentProvider };